.icon{position:relative;font-size:37px;left:-5px}p-inputgroup:has(.p-radiobutton-checked){border-color:#436807!important;border-width:2px!important;background-color:#d1e09b!important}
/*# sourceMappingURL=customer-wizard-step-3.page-P2IM4VPP.css.map */
